




import { defineComponent, PropType, inject, ref, onMounted, onBeforeUnmount } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import SchedulePostView from "../SchedulePostView";

export default defineComponent({
  name: "SchedulePostController",
  components: { SchedulePostView },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props) {
    const show = ref(false);
    const updatePostData = inject<(postData: ContentSet) => void>("updatePostData", async () => {});
    const onShow = () => {
      show.value = true;
    };

    const onSave = async (date: Date) => {
      try {
        if (!props.postData.scheduleTime && date.getTime() <= new Date().getTime()) return;
        const postData = await providers.ContentSetProvider.update({
          data: {
            id: props.postData.id,
            scheduleTime: date.toISOString(),
          },
        });
        updatePostData(postData);
      } finally {
        show.value = false;
      }
    };

    onMounted(() => {
      emitter.on<any>(EVENTS.CONTENT_FEED_SCHEDULE_POST_SHOW, onShow);
    });

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.CONTENT_FEED_SCHEDULE_POST_SHOW, onShow);
    });

    return { show, onSave };
  },
});
